import { render } from "./lead-technology-asset-edition-form.vue?vue&type=template&id=4002b3d0&scoped=true&ts=true"
import script from "./lead-technology-asset-edition-form.vue?vue&type=script&lang=ts"
export * from "./lead-technology-asset-edition-form.vue?vue&type=script&lang=ts"

import "./lead-technology-asset-edition-form.vue?vue&type=style&index=0&id=4002b3d0&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./../../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fpages%2Flead-overview%2Fcomponents%2Fasset-classification%2Fcomponents%2Flead-technology-asset%2Flead-technology-asset-edition-form.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4002b3d0"]])

export default __exports__